/* Offre cadeau Alo : 100 € d'achat Alo = casquette + chaussettes Alo offertes.
   Add-on autonome : s'accroche au panier existant (window.loadCart) sans le réécrire.
   Réduction Shopify associée : "Cadeaux Alo — 100€ d'achat = casquette + chaussettes offertes". */
(function () {
  var CFG = {
    threshold: 10000,                 // 100,00 € (centimes)
    capProductId: 15614720934236,     // Casquette District Trucker Alo - Noir
    capVariantId: 57796632904028,
    sockProductId: 15614720999772,    // Chaussettes Mi-Mollet Alo - Noir/Blanc
    sockVariantId: 57796633002332,    // taille M par défaut
    collectionHandle: 'ensembles-alo-femme'
  };
  var busy = false;
  var aloIds = null;

  function fmt(c) { return (c / 100).toFixed(2).replace('.', ','); }

  function injectStyles() {
    if (document.getElementById('alo-gift-style')) return;
    var s = document.createElement('style');
    s.id = 'alo-gift-style';
    s.textContent = '.gift-bar{padding:10px 16px;background:#fff7ed;border-bottom:1px solid #fde6c8}.gift-bar__text{font-size:12px;color:#9a3412;margin:0 0 8px;text-align:center}.gift-bar__track{height:6px;background:#fde6c8;border-radius:99px;overflow:hidden}.gift-bar__fill{height:100%;background:#f59e0b;border-radius:99px;transition:width .4s ease}.gift-bar--reached{background:#f0faf0;border-bottom-color:#bbf7d0}.gift-bar--reached .gift-bar__text{color:#16a34a}.gift-bar--reached .gift-bar__fill{background:#22c55e}';
    document.head.appendChild(s);
  }

  function ensureBar() {
    if (document.getElementById('cart-gift-bar')) return;
    var ship = document.getElementById('cart-shipping-bar');
    if (!ship || !ship.parentNode) return;
    var d = document.createElement('div');
    d.id = 'cart-gift-bar';
    ship.parentNode.insertBefore(d, ship.nextSibling);
  }

  async function loadAloIds() {
    if (aloIds) return aloIds;
    var ids = [];
    try {
      for (var page = 1; page <= 4; page++) {
        var r = await fetch('/collections/' + CFG.collectionHandle + '/products.json?limit=250&page=' + page);
        if (!r.ok) break;
        var d = await r.json();
        if (!d.products || !d.products.length) break;
        d.products.forEach(function (p) { ids.push(p.id); });
        if (d.products.length < 250) break;
      }
    } catch (e) {}
    aloIds = ids;
    return ids;
  }

  function aloSubtotal(cart, ids) {
    var t = 0;
    cart.items.forEach(function (it) {
      if (it.product_id === CFG.capProductId || it.product_id === CFG.sockProductId) return;
      if (ids.indexOf(it.product_id) !== -1) t += it.original_line_price;
    });
    return t;
  }

  function renderBar(sub) {
    var el = document.getElementById('cart-gift-bar');
    if (!el) return;
    if (sub <= 0) { el.innerHTML = ''; return; }
    var remaining = Math.max(0, CFG.threshold - sub);
    var pct = Math.min(100, Math.round(sub / CFG.threshold * 100));
    if (remaining > 0) {
      el.innerHTML = '<div class="gift-bar"><p class="gift-bar__text">Plus que <strong>' + fmt(remaining) + ' €</strong> d\'Alo = <strong>casquette + chaussettes offertes</strong></p><div class="gift-bar__track"><div class="gift-bar__fill" style="width:' + pct + '%"></div></div></div>';
    } else {
      el.innerHTML = '<div class="gift-bar gift-bar--reached"><p class="gift-bar__text"><strong>Casquette + chaussettes offertes</strong> ajoutées !</p><div class="gift-bar__track"><div class="gift-bar__fill" style="width:100%"></div></div></div>';
    }
  }

  async function manageGifts(cart, sub) {
    if (busy) return false;
    var hasCap = cart.items.some(function (i) { return i.product_id === CFG.capProductId; });
    var hasSock = cart.items.some(function (i) { return i.product_id === CFG.sockProductId; });
    if (sub >= CFG.threshold) {
      var add = [];
      if (!hasCap) add.push({ id: CFG.capVariantId, quantity: 1 });
      if (!hasSock) add.push({ id: CFG.sockVariantId, quantity: 1 });
      if (add.length) {
        busy = true;
        try { await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: add }) }); } catch (e) {}
        busy = false;
        if (window.loadCart) window.loadCart();
        return true;
      }
    } else if (hasCap || hasSock) {
      var up = {};
      cart.items.forEach(function (i) { if (i.product_id === CFG.capProductId || i.product_id === CFG.sockProductId) up[i.key] = 0; });
      busy = true;
      try { await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: up }) }); } catch (e) {}
      busy = false;
      if (window.loadCart) window.loadCart();
      return true;
    }
    return false;
  }

  async function pass() {
    ensureBar();
    var ids = await loadAloIds();
    var cart;
    try { cart = await (await fetch('/cart.js')).json(); } catch (e) { return; }
    var el = document.getElementById('cart-gift-bar');
    if (!cart || !cart.items || !cart.items.length) { if (el) el.innerHTML = ''; return; }
    var sub = aloSubtotal(cart, ids);
    var mutated = await manageGifts(cart, sub);
    if (mutated) return; // loadCart relancé -> nouveau pass via wrapper
    renderBar(sub);
  }

  function wrap() {
    if (typeof window.loadCart !== 'function') return false;
    if (window.__aloWrapped) return true;
    var orig = window.loadCart;
    window.loadCart = function () {
      var r = orig.apply(this, arguments);
      Promise.resolve(r).then(function () { pass(); });
      return r;
    };
    window.__aloWrapped = true;
    return true;
  }

  function init() {
    injectStyles();
    if (!wrap()) {
      var tries = 0;
      var iv = setInterval(function () { tries++; if (wrap() || tries > 40) clearInterval(iv); }, 150);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
